import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { AlertState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: AlertState = {
  alerts: [],
  error: { state: false }
}

const namespaced: boolean = true

export const alerts: Module<AlertState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
